import React from "react";
import {inject, observer} from "mobx-react";
import Mediatheque from "./Mediatheque";

/**
 * Choix d'une image dans la médiathèque (fenêtre ouverte depuis un produit, un article, un fond de l'écran client...).
 * L'image choisie est posée dans imageStore.pickAsset puis onCallback est appelé, comme avant.
 */
const PickAsset = inject("rootStore")(observer(function PickAsset({rootStore, onCallback}) {
    return <Mediatheque mode="choisir"
                        onChoisir={asset => {
                            rootStore.imageStore.pickAsset = asset;
                            onCallback && onCallback();
                        }}/>;
}));

export default PickAsset;
